/* SPDX-License-Identifier: AGPL-3.0-or-later */

import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { TeamDto, TournamentQualificationMatchDto } from '@api';
import { TournamentTeamEditComponent } from '../components/tournament-team-edit/tournament-team-edit.component';
import {
  TournamentEditMatchResultsDialogComponent,
  TournamentEditMatchResultsDialogData,
} from '../components/tournament/tournament-edit-match-results-dialog/tournament-edit-match-results-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class TournamentDialogsService {
  matDialog = inject(MatDialog);

  /*
   * Opens a dialog to edit the details of a participating team of a tournament.
   * @param tournamentId ID of the tournament the team belongs to
   * @param team The details of the team to edit
   * @return whether the team was updated or not
   */
  async openTeamEditDialog(tournamentId: number, team: TeamDto): Promise<boolean> {
    const dialogRef = this.matDialog.open(TournamentTeamEditComponent, {
      width: '600px',
      maxWidth: '750px',
      data: { tournamentId, team },
    });

    return (await firstValueFrom(dialogRef.afterClosed())) === true;
  }

  /*
   * Opens a dialog to edit the match results of a qualification match
   * @param tournamentId ID of the tournament the qualification match is part of
   * @param
   * @return whether the team was updated or not
   */
  async openQualificationMatchResultDialog(
    data: TournamentEditMatchResultsDialogData,
  ): Promise<TournamentQualificationMatchDto | null> {
    const dialogRef = this.matDialog.open(TournamentEditMatchResultsDialogComponent, {
      width: '600px',
      maxWidth: '750px',
      data,
    });

    return await firstValueFrom(dialogRef.afterClosed());
  }
}
